import { ref, computed } from "@vue/composition-api";

import { requestLoadListings } from "@/service/ListingsService";

const allListings = ref([]);
export const filterBy = ref(null);
const perPage = ref(10);
const loading = ref(false);
let lastPageItem = 0;
let firstPageItem = 0;
const totalRows = ref(0);

export const setPerPage = (val) => (perPage.value = val);
export const getPerPage = computed(() => perPage.value);
export const getLoading = computed(() => loading.value);
export const getTotalRows = computed(() => totalRows.value);
export const getAllListings = computed(() => allListings.value);

export const sortBy = ref("label");
export const sortOrder = ref("asc");

function getSort() {
  switch (sortBy.value) {
    case "name":
      return "listings.name";
    case "listingPrice":
      return "listing_price";
    case "availableQuantity":
      return "available_quantity";
    default:
      return sortBy.value;
  }
}

export const onLoadAllListings = async ({ prevPage, nextPage, reset }) => {
  let useLast = 0;
  if (!reset) {
    if (nextPage) {
      useLast = lastPageItem;
    }
    if (prevPage) {
      useLast = firstPageItem - 1;
    }
  }
  const reqData = {
    lastItem: useLast,
    perPage: perPage.value,
    sort: getSort(),
    sortOrder: sortOrder.value,
    filter: {
      search: filterBy.value || null
    }
  };
  loading.value = true;
  try {
    const {
      data: { listings, pagination }
    } = await requestLoadListings(reqData);

    if (listings) {
      allListings.value.splice(0, allListings.value.length);
      allListings.value.push(...listings);
    } else {
      allListings.value.splice(0, allListings.value.length);
    }
    lastPageItem = pagination.lastItem;
    firstPageItem = pagination.firstItem;
    totalRows.value = pagination.totalRows ? pagination.totalRows : 10;
  } finally {
    loading.value = false;
  }
};
